module.exports = __webpack_public_path__ + "static/media/topic.dc80baf5.svg";